export const ANALYTIC_ID_NAVIGATE_BUTTON = 'NavigateButton';
export const ANALYTIC_ID_NAVIGATE_AGENDA = 'NavigateAgenda';
export const ANALYTIC_ID_NAVIGATE_AGENDA_BUTTON = 'NavigateAgendaButton';

export const ANALYTIC_ID_NOTE = 'Note';
export const ANALYTIC_ID_NOTE_DELETE = 'NoteDelete';

/** Tagged by the document viewer drawer onto whichever trigger an embed opens a document with. */
export const ANALYTIC_ID_DOCUMENT_OPENED = 'DocumentOpened';

/** Tagged onto each family menu item of the RAF card; `from` and `to` carry the switch. */
export const ANALYTIC_ID_RAF_FAMILY_SELECTED = 'RafFamilySelected';
export const ANALYTIC_ID_NEW_RELEASE_RELOAD = 'NewReleaseReload';
export const ANALYTIC_ID_NEW_RELEASE_DISMISS = 'NewReleaseDismiss';
